import * as React from 'react';
import { createSvgIcon } from '@mui/material';
/* Required is custom icon displayed in the ACL action Grid*/

var ReadOnly = createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "ReadOnly-map",
  width: "50",
  height: "50",
  x: "0",
  y: "0"
}), /*#__PURE__*/React.createElement("path", {
  id: "ReadOnly-path",
  d: "M4.41421356,3 L20.9142136,19.5 L19.5,20.9142136 L13.168,14.5815 L6.75,21 L3,21 L3,17.25 L9.418,10.8315 L3,4.41421356 L4.41421356,3 Z M14.06,6.19 L17.81,9.94 L15.957,11.7925 L12.207,8.0425 L14.06,6.19 Z M20.71,7.04 C21.1,6.65 21.1,6.02 20.71,5.63 L18.37,3.29 C17.98,2.9 17.35,2.9 16.96,3.29 L15.13,5.12 L18.88,8.87 L20.71,7.04 L20.71,7.04 Z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ReadOnly-mask",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  href: "#ReadOnly-path"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#ReadOnly-mask)"
}, /*#__PURE__*/React.createElement("use", {
  href: "#ReadOnly-map",
  fill: "#616161",
  transform: "translate(-13 -13)"
})))), 'ReadOnly');
export { ReadOnly };